import {
  MenuItem,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Pagination,
} from "@mui/material";
import Select from "../Select";

export interface IPaginationProps {
  page: number;
  perPage: number;
  total: number;
  onPageChange: (newPage: number) => void;
  onPerPageChange: (perPage: number) => void;
  perPageOptions?: number[];
}

export const CustomPagination = ({
  page,
  perPage,
  total,
  onPageChange,
  onPerPageChange,
  perPageOptions = [10, 20, 50, 100],
}: IPaginationProps) => {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const isExtraSmall = useMediaQuery(theme.breakpoints.down(350));

  const totalPages = Math.ceil(total / perPage);

  const renderResultText = () => {
    const firstIndex = (page - 1) * perPage + 1;
    const lastIndex = page * perPage;
    const results = Math.min(lastIndex, total) - firstIndex + 1;
    return (
      <Typography variant="body2">
        {`${firstIndex}-${lastIndex} of ${total}`}
      </Typography>
    );
  };

  return (
    <Box
      display="flex"
      flexDirection={isExtraSmall ? "column" : "row"}
      justifyContent="space-between"
      alignItems="center"
      mt={1}
      gap={1}
    >
      <Box display="flex" alignItems="center">
        {smUp && (
          <Typography variant="body2">Results per page:&nbsp;</Typography>
        )}
        <Select
          value={perPage}
          onChange={(e) => onPerPageChange(e.target.value as number)}
          size="small"
        >
          {perPageOptions.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </Select>
      </Box>
      {smUp && renderResultText()}
      <Box display="flex" alignItems="center" gap={1} flexWrap={"nowrap"}>
        <Pagination
          page={page}
          count={totalPages}
          variant="text"
          shape="rounded"
          size="small"
          onChange={(_e, value: number) => onPageChange(value)}
        />
      </Box>
    </Box>
  );
};

export default CustomPagination;
